const projects = [
  {
    title: "Choropleth Map",
    codeLink: "https://github.com/D20CM/FCC-Choropleth",
    liveLink: "https://d20cm.github.io/FCC-Choropleth/",
    screenshot: "../images/choropleth-screenshot.png",
    description:
      "A choropleth chart made with D3.js, visualising US educational attainment levels by county.",
  },
  {
    title: "Drum Machine",
    codeLink: "https://github.com/D20CM/drummachine",
    liveLink: "https://drum-machine-d20cm.netlify.app/",
    screenshot: "../images/drum-machine.png",
    description:
      "A drum machine / sample pad app built with React class-based components.  This features a volume slider, bank switch, and sample name display.  Sounds can be triggered from the keyboard or by clicking on the corresponding pad on screen.",
  },
  {
    title: "Briton Ferry Band Website",
    codeLink: "https://github.com/D20CM/BritonFerrySilverBand",
    liveLink: "http://www.britonferrysilverband.org.uk/",
    screenshot: "../images/bf-band-website.png",
    description:
      "A website I made for Briton Ferry Silver Band, a brass band of which I've been a member of for nearly 25 years.  The site was built with just HTML and CSS, is fully responsive, and features social media feeds, image carousel, and contact page with map.",
  },
  {
    title: "Pomodoro Timer",
    codeLink: "https://github.com/D20CM/twenty-five-and-five-clock",
    liveLink: "https://sb-pomodoro-timer.netlify.app/",
    screenshot: "../images/pomodoro-timer.png",
    description:
      "A pomodoro timer built with React class based components, featuring customisable work/break time chunks, reset, start/pause buttons, and an alarm that sounds after the set time period has elapsed.",
  },
];

export default projects;
